import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_CANCEL_SERIVICE_TICKETS, GET_SERIVICE_TICKETS, INSERT_SERVICE_TICKET,
  GET_SERVICE_TYPES, GET_SERVICE_SUB_TYPES, SF_FILE_UPLOAD, GET_SERIVICE_ALL_TICKETS

} from "../../../../Urls.js";

const initialState = {
  viewServiceTiketData: {},
  serviceTickets: { data: [], loader: false },
  gasLineserviceTickets: { data: [], loader: false },
  gasMeterServiceTickets: { data: [], loader: false },
  fiberLineServiceTickets: { data: [], loader: false },
  createServiceTicketData: { data: {}, loader: false },
  cancelServiceTicketData: { data: {}, loader: false },
  updateServiceTicket: { data: {}, loader: false },
  serviceCategory: { data: [], loader: false },
  servcieSubCategory: { data: [], loader: false },
};

export const getServiceCategory = createAsyncThunk(
  "app/get/getServiceCategory",
  async (userTypeCode) => {
    const response = await axios.get(GET_SERVICE_TYPES + userTypeCode);
    return response;
  }
);

export const getServiceSubCategory = createAsyncThunk(
  "app/get/getServiceSubCategory",
  async (userTypeCode) => {
    const response = await axios.get(GET_SERVICE_SUB_TYPES + userTypeCode);
    return response;
  }
);

export const getServiceTickets = createAsyncThunk(
  "app/get/getServiceTickets",
  async (reqData) => {
    const response = await axios.post(GET_SERIVICE_TICKETS, { ...reqData });
    return response;
  }
);

export const getCancelServiceTickets = createAsyncThunk(
  "app/get/getCancelServiceTickets",
  async (reqData) => {
    const response = await axios.post(GET_CANCEL_SERIVICE_TICKETS, { ...reqData });
    return response;
  }
);

export const getGasLineServiceTickets = createAsyncThunk(
  "app/get/getGasLineServiceTickets",
  async (reqData) => {
    const response = await axios.post(GET_SERIVICE_ALL_TICKETS, { ...reqData });
    return response;
  }
);

export const getFiberLineServiceTickets = createAsyncThunk(
  "app/get/getFiberLineServiceTickets",
  async (reqData) => {
    const response = await axios.post(GET_SERIVICE_TICKETS, { ...reqData });
    return response;
  }
);

export const getGasMeterServiceTickets = createAsyncThunk(
  "app/get/getGasMeterServiceTickets",
  async (reqData) => {
    const response = await axios.post(GET_SERIVICE_TICKETS, { ...reqData });
    return response;
  }
);

export const updateServiceTikets = createAsyncThunk(
  "app/get/updateServiceTicket",
  async () => {
    const response = await axios.get(`/api/v1/customer/getAppData`);
    return response;
  }
);

export const createServiceTickets = createAsyncThunk(
  "app/get/createServiceTicket",
  async (data) => {
    const response = await axios.post(INSERT_SERVICE_TICKET, { ...data });
    return response;
  }
);
export const sffileupload = createAsyncThunk(
  "app/get/sffileupload",
  async (data) => {
    const response = await axios.post(SF_FILE_UPLOAD, { ...data });
    return response;
  }
);

export const serviceTicketSlice = createSlice({
  name: "app/serviceTicketSlice",
  initialState,
  reducers: {
    addServiceTickets: (state, action) => {
      console.table(action.payload);
      console.table(state.serviceTickets[0]);
      let currentTickets = [...state.serviceTickets];
      currentTickets.push(action.payload);
      state.serviceTickets = currentTickets;
    },
    setViewServiceTicket: (state, action) => {
      state.viewServiceTiketData = action.payload;
    },
    setServiceCategories: (state, action) => {
      state.setServiceCategories = action.payload
    }
  },

  extraReducers: (builder) => {
    builder

      .addCase(getServiceTickets.pending, (state) => {
        state.serviceTickets.loader = true;
      })
      .addCase(getServiceTickets.fulfilled, (state, action) => {
        state.serviceTickets.loader = false;
        state.serviceTickets.data = action?.payload?.data?.data;
      })
      .addCase(getServiceTickets.rejected, (state) => {
        state.serviceTickets.loader = false;
      })

      // Cancel Service ticket
      .addCase(getCancelServiceTickets.pending, (state) => {
        state.cancelServiceTicketData.loader = true;
      })
      .addCase(getCancelServiceTickets.fulfilled, (state, action) => {
        state.cancelServiceTicketData.loader = false;
        state.cancelServiceTicketData.data = action?.payload?.data?.data;
      })
      .addCase(getCancelServiceTickets.rejected, (state) => {
        state.cancelServiceTicketData.loader = false;
      })


      //
      .addCase(getGasLineServiceTickets.pending, (state) => {
        state.gasLineserviceTickets.loader = true;
      })
      .addCase(getGasLineServiceTickets.fulfilled, (state, action) => {
        state.gasLineserviceTickets.loader = false;
        state.gasLineserviceTickets.data = action?.payload?.data?.data;
      })
      .addCase(getGasLineServiceTickets.rejected, (state) => {
        state.gasLineserviceTickets.loader = false;
      })


      //Fiber Line
      .addCase(getFiberLineServiceTickets.pending, (state) => {
        state.fiberLineServiceTickets.loader = true;
      })
      .addCase(getFiberLineServiceTickets.fulfilled, (state, action) => {
        state.fiberLineServiceTickets.loader = false;
        state.fiberLineServiceTickets.data = action?.payload?.data?.data;
      })
      .addCase(getFiberLineServiceTickets.rejected, (state) => {
        state.fiberLineServiceTickets.loader = false;
      })

      //Gas Meter
      .addCase(getGasMeterServiceTickets.pending, (state) => {
        state.gasMeterServiceTickets.loader = true;
      })
      .addCase(getGasMeterServiceTickets.fulfilled, (state, action) => {
        state.gasMeterServiceTickets.loader = false;
        state.gasMeterServiceTickets.data = action?.payload?.data?.data;
      })
      .addCase(getGasMeterServiceTickets.rejected, (state) => {
        state.gasMeterServiceTickets.loader = false;
      })

      // Service type category
      .addCase(getServiceCategory.pending, (state) => {
        state.serviceCategory.loader = true;
      })
      .addCase(getServiceCategory.fulfilled, (state, action) => {
        state.serviceCategory.loader = false;
        state.serviceCategory.data = action?.payload?.data?.data;
      })
      .addCase(getServiceCategory.rejected, (state) => {
        state.serviceCategory.loader = false;
      })

      // Service sub type category
      .addCase(getServiceSubCategory.pending, (state) => {
        state.servcieSubCategory.loader = true;
      })
      .addCase(getServiceSubCategory.fulfilled, (state, action) => {
        state.servcieSubCategory.loader = false;
        state.servcieSubCategory.data = action?.payload?.data?.data;
      })
      .addCase(getServiceSubCategory.rejected, (state) => {
        state.servcieSubCategory.loader = false;
        state.servcieSubCategory.data = [];
      })


      .addCase(updateServiceTikets.pending, (state) => {
        state.updateServiceTickets.loader = true;
      })
      .addCase(updateServiceTikets.fulfilled, (state, action) => {
        state.updateServiceTikets.loader = false;
        state.appData.data = action?.payload?.data?.data;
      })
      .addCase(updateServiceTikets.rejected, (state) => {
        state.updateServiceTikets.loader = false;
        state.updateServiceTikets.data = [];
      })
      .addCase(createServiceTickets.pending, (state) => {
        state.createServiceTicketData.loader = true;
      })
      .addCase(createServiceTickets.fulfilled, (state, action) => {
        state.createServiceTicketData.loader = false;
        state.createServiceTicketData.data = action?.payload?.data?.data;
      })
      .addCase(createServiceTickets.rejected, (state) => {
        state.createServiceTicketData.loader = false;
        state.createServiceTicketData.data = [];
      });
  },
});

export const getReduxServiceTickets = (state) => state.serviceTicketSlice.serviceTickets;

export const { addServiceTickets, setViewServiceTicket } = serviceTicketSlice.actions;

export default serviceTicketSlice.reducer;
